import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { getUserAuthentication } from 'selectors';
import StyledHeaderContainer, {
  Logo,
} from 'components/layout/header/styledHeaderContainer';
import { Messages, NotificationsList } from './components';

const Header = ({ theme, ...rest }) => {
  const logo = theme.icons.header;
  const isAuthorized = useSelector(getUserAuthentication);

  return (
    <StyledHeaderContainer {...rest}>
      <Logo className="logo" src={logo} disabled={!isAuthorized} />
      <Stack direction="row" spacing={1}>
        {isAuthorized && (
          <>
            <Messages />
            <NotificationsList />
          </>
        )}
      </Stack>
    </StyledHeaderContainer>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

Header.defaultProps = {
  className: '',
};

export default withTheme(Header);
